import React from 'react'
import { QuestionFrame, YesNoQuestion } from 'components/questions'


export const Q11 = () => {

  return (
    <QuestionFrame q={11}>

      <YesNoQuestion num={1} content={'受水槽・高架水槽（上水用）がありますか。'} />
      <YesNoQuestion num={2} content={'井水を利用していますか。'} />
      <YesNoQuestion num={3} content={'中水を利用していますか。'} />
      <YesNoQuestion num={4} content={'建物外からの逆流の恐れがない汚水排水槽はありますか。'} />
      <YesNoQuestion num={5} content={'断水時に利用できるトイレ（常時設置されたトイレに限る）がありますか。'} />
      <YesNoQuestion num={6} content={'災害対応型LPガスシステムがありますか、又はガスを利用せずに建物の運営を維持できますか。'} />

    </QuestionFrame>
  )
}
